import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import uiState from './uiState'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false,


  modules: {
    user,       // ログイン状態のユーザの情報
    uiState,    // Vue Components の UI ステータス情報
  },
})
